var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _g2, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyntiroLogoHorizontalWhiteTextSlogan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4497,
    height: 959,
    viewBox: "36 35.7 523.6 111.65",
    role: "img",
    "aria-label": "Syntiro",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #03ac96;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #00ab97;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #006a77;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 85.2,
    y: 40.96,
    width: 2.51,
    height: 100.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 106.92,
    y: 53.5,
    width: 2.51,
    height: 75.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 128.65,
    y: 66.04,
    width: 2.51,
    height: 50.17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 41.76,
    y: 66.04,
    width: 2.51,
    height: 50.17
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 63.48,
    y: 53.5,
    width: 2.51,
    height: 75.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.47,91.13c0,3.87-3.14,7.01-7.01,7.01s-7.01-3.14-7.01-7.01,3.14-7.01,7.01-7.01,7.01,3.14,7.01,7.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.02,91.13c0,3.87-3.14,7.01-7.01,7.01s-7.01-3.14-7.01-7.01,3.14-7.01,7.01-7.01,7.01,3.14,7.01,7.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.18,84.72c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.18,109.8c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.46,71.3c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.46,123.22c-3.39,0-6.14-2.75-6.14-6.13s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.13-6.14,6.13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.91,91.13c0,3.87-3.14,7.01-7.01,7.01s-7.01-3.14-7.01-7.01,3.14-7.01,7.01-7.01,7.01,3.14,7.01,7.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,40.96c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,141.29c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.92,53.5c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.92,128.75c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.64,66.04c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.36-5.26-5.26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.75,66.04c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.36-5.26-5.26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.64,116.21c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.75,116.21c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.73,84.72c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.73,109.8c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.48,53.5c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.48,128.75c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.27,114.35c-11.82,0-20.73-8.57-20.73-21.66s8.92-21.54,20.73-21.54,20.62,8.46,20.62,21.54-8.8,21.66-20.62,21.66M506.27,124.08c18.42,0,31.85-13.09,31.85-31.39s-13.44-31.27-31.85-31.27-31.97,12.97-31.97,31.27,13.55,31.39,31.97,31.39M448.09,72.3v-10.31h-10.66v61.39h11.12v-30.58c0-13.44,7.41-20.73,19.34-20.73.81,0,1.62,0,2.55.12v-10.77c-10.77,0-18.42,3.71-22.35,10.89M409.72,123.38h11.12v-61.39h-11.12v61.39ZM415.28,50.18c4.4,0,7.53-3.24,7.53-7.41,0-3.94-3.24-7.06-7.53-7.06s-7.53,3.24-7.53,7.3,3.24,7.18,7.53,7.18M397.06,111.8c-2.32,1.85-5.44,2.9-8.69,2.9-6.14,0-9.61-3.71-9.61-10.31v-33.24h17.61v-9.15h-17.61v-13.44h-11.12v13.44h-10.43v9.15h10.43v33.71c0,12.39,7.07,19.23,19.46,19.23,4.98,0,10.08-1.39,13.44-4.29l-3.48-7.99ZM324.91,61.42c-9.73,0-17.61,3.59-22.12,9.85v-9.27h-10.66v61.39h11.12v-31.62c0-13.32,7.64-20.39,19.46-20.39,10.54,0,16.56,5.91,16.56,17.95v34.05h11.12v-35.33c0-18.07-10.54-26.64-25.48-26.64M273.35,61.99l-21.2,49.11-21.43-49.11h-11.58l27.1,61.27-1.97,4.29c-3.01,7.07-6.37,9.5-11.7,9.5-4.17,0-7.99-1.62-11-4.52l-4.75,8.34c3.82,3.71,9.85,5.68,15.75,5.68,9.38,0,16.45-4.05,21.89-17.03l29.77-67.53h-10.89ZM189.74,124.08c16.33,0,26.52-7.07,26.52-18.18,0-23.86-38.92-12.05-38.92-26.53,0-4.87,4.75-8.46,14.48-8.46,6.02,0,12.16,1.27,17.72,4.86l4.75-8.8c-5.33-3.48-14.36-5.56-22.35-5.56-15.75,0-25.6,7.41-25.6,18.42,0,24.44,38.8,12.51,38.8,26.29,0,5.21-4.29,8.34-14.59,8.34-7.99,0-16.33-2.66-21.54-6.37l-4.63,8.8c5.1,4.05,15.17,7.18,25.37,7.18"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.86,142.22v1.81h-8.7v-11.6h8.47v1.81h-6.31v3.02h5.6v1.77h-5.6v3.2h6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.79,138.95v5.07h-2.07v-4.81c0-1.57-.78-2.34-2.1-2.34-1.47,0-2.47.9-2.47,2.67v4.47h-2.07v-8.85h1.97v1.14c.68-.81,1.76-1.24,3.05-1.24,2.12,0,3.7,1.21,3.7,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.79,140.26h-6.94c.25,1.29,1.33,2.12,2.87,2.12,1,0,1.77-.31,2.4-.96l1.11,1.28c-.8.94-2.04,1.44-3.56,1.44-2.97,0-4.89-1.91-4.89-4.54s1.94-4.52,4.57-4.52,4.47,1.81,4.47,4.57c0,.17-.02.41-.03.61ZM386.83,138.89h5.02c-.17-1.28-1.14-2.15-2.5-2.15s-2.32.86-2.52,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.94,135.07v1.97c-.18-.03-.33-.05-.48-.05-1.57,0-2.57.93-2.57,2.73v4.29h-2.07v-8.85h1.97v1.29c.6-.93,1.67-1.39,3.15-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.4,135.17v7.51c0,3.21-1.67,4.67-4.77,4.67-1.66,0-3.3-.43-4.31-1.26l.93-1.56c.78.65,2.04,1.06,3.26,1.06,1.96,0,2.82-.89,2.82-2.68v-.46c-.73.79-1.77,1.18-2.97,1.18-2.54,0-4.47-1.72-4.47-4.29s1.94-4.26,4.47-4.26c1.24,0,2.34.4,3.07,1.28v-1.18h1.97ZM409.36,139.33c0-1.49-1.13-2.5-2.68-2.5s-2.7,1.01-2.7,2.5,1.13,2.54,2.7,2.54,2.68-1.03,2.68-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.4,135.17l-4.14,9.56c-.81,2-1.94,2.62-3.41,2.62-.88,0-1.81-.3-2.37-.81l.83-1.52c.4.38.96.61,1.52.61.73,0,1.16-.35,1.56-1.23l.15-.35-3.86-8.88h2.15l2.78,6.54,2.8-6.54h1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.47,142.76c0-.83.61-1.38,1.36-1.38s1.36.55,1.36,1.38-.61,1.38-1.36,1.38-1.36-.58-1.36-1.38Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.96,141.34h-5.8l-1.14,2.68h-2.22l5.22-11.6h2.12l5.24,11.6h-2.25l-1.16-2.68ZM439.25,139.65l-2.19-5.07-2.17,5.07h4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.84,139.6c0-2.65,1.99-4.52,4.79-4.52,1.72,0,3.1.71,3.78,2.05l-1.59.93c-.53-.84-1.33-1.23-2.2-1.23-1.52,0-2.68,1.06-2.68,2.77s1.16,2.77,2.68,2.77c.88,0,1.67-.38,2.2-1.23l1.59.93c-.68,1.33-2.05,2.07-3.78,2.07-2.8,0-4.79-1.89-4.79-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.34,139.6c0-2.65,1.99-4.52,4.79-4.52,1.72,0,3.1.71,3.78,2.05l-1.59.93c-.53-.84-1.33-1.23-2.2-1.23-1.52,0-2.68,1.06-2.68,2.77s1.16,2.77,2.68,2.77c.88,0,1.67-.38,2.2-1.23l1.59.93c-.68,1.33-2.05,2.07-3.78,2.07-2.8,0-4.79-1.89-4.79-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.86,139.6c0-2.65,1.99-4.52,4.71-4.52s4.72,1.87,4.72,4.52-1.97,4.54-4.72,4.54-4.71-1.89-4.71-4.54ZM470.2,139.6c0-1.69-1.13-2.77-2.63-2.77s-2.62,1.08-2.62,2.77,1.13,2.77,2.62,2.77,2.63-1.08,2.63-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M482.84,135.17v8.85h-1.97v-1.13c-.66.81-1.71,1.24-2.85,1.24-2.27,0-3.81-1.24-3.81-3.91v-5.05h2.07v4.77c0,1.61.76,2.37,2.07,2.37,1.44,0,2.42-.89,2.42-2.67v-4.47h2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.28,138.95v5.07h-2.07v-4.81c0-1.57-.78-2.34-2.1-2.34-1.47,0-2.47.9-2.47,2.67v4.47h-2.07v-8.85h1.97v1.14c.68-.81,1.76-1.24,3.05-1.24,2.12,0,3.7,1.21,3.7,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.24,143.54c-.5.4-1.24.6-1.99.6-1.94,0-3.05-1.03-3.05-2.98v-4.26h-1.46v-1.66h1.46v-2.02h2.07v2.02h2.37v1.66h-2.37v4.21c0,.86.43,1.33,1.23,1.33.43,0,.84-.12,1.16-.36l.58,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.93,140.26h-6.94c.25,1.29,1.33,2.12,2.87,2.12,1,0,1.77-.31,2.4-.96l1.11,1.28c-.8.94-2.04,1.44-3.56,1.44-2.97,0-4.89-1.91-4.89-4.54s1.94-4.52,4.57-4.52,4.47,1.81,4.47,4.57c0,.17-.02.41-.03.61ZM504.97,138.89h5.02c-.17-1.28-1.14-2.15-2.5-2.15s-2.32.86-2.52,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.63,131.73v12.3h-1.99v-1.14c-.7.85-1.72,1.26-2.93,1.26-2.57,0-4.47-1.79-4.47-4.54s1.91-4.52,4.47-4.52c1.14,0,2.15.38,2.85,1.19v-4.54h2.07ZM520.59,139.6c0-1.69-1.14-2.77-2.63-2.77s-2.63,1.08-2.63,2.77,1.14,2.77,2.63,2.77,2.63-1.08,2.63-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.09,134.23v3.53h5.6v1.82h-5.6v4.44h-2.15v-11.6h8.47v1.81h-6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.34,139.6c0-2.65,1.99-4.52,4.71-4.52s4.72,1.87,4.72,4.52-1.97,4.54-4.72,4.54-4.71-1.89-4.71-4.54ZM546.68,139.6c0-1.69-1.13-2.77-2.63-2.77s-2.62,1.08-2.62,2.77,1.13,2.77,2.62,2.77,2.63-1.08,2.63-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.88,135.07v1.97c-.18-.03-.33-.05-.48-.05-1.57,0-2.57.93-2.57,2.73v4.29h-2.07v-8.85h1.97v1.29c.6-.93,1.67-1.39,3.15-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M556.88,142.76c0-.83.61-1.38,1.36-1.38s1.36.55,1.36,1.38-.61,1.38-1.36,1.38-1.36-.58-1.36-1.38Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.94,61.9l-3.36,5.62-3.39-5.62h-1.59v10.59h1.41v-8.28l3.47,5.77h.17s3.47-5.76,3.47-5.76v8.28h1.39v-10.59h-1.57ZM535.57,61.9v1.33h3.12v9.26h1.39v-9.26h3.13v-1.33h-7.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyntiroLogoHorizontalWhiteTextSlogan);
export default __webpack_public_path__ + "static/media/syntiro-logo-horizontal-white-text-slogan.d5777af6a56b4211cee33b7184e6b0ce.svg";
export { ForwardRef as ReactComponent };